import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import useRouteName from "./useRouteName.js";
const useCaParamsCleanup = () => {
    const history = useHistory();
    const routeName = useRouteName();
    return useCallback(() => {
        const currentUrlParams = new URLSearchParams(window.location.search);
        let needsUpdate = false;
        if (currentUrlParams.has("ca_source") && routeName !== "flightdetails") {
            currentUrlParams.delete("ca_source");
            needsUpdate = true;
        }
        if (currentUrlParams.has("ca_price") && routeName !== "flightdetails") {
            currentUrlParams.delete("ca_price");
            needsUpdate = true;
        }
        if (needsUpdate) {
            history.replace(`${window.location.pathname}?${currentUrlParams.toString()}${window.location.hash}`);
        }
        return needsUpdate;
    }, [history, routeName]);
};
export default useCaParamsCleanup;
